import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { useMe } from "../../hooks/queries";
import { TermsConditions } from "../../models/termsConditionsData";
import DataSvc from "../../services/dataSvc";
import { modalViewGAEvent } from "../../utils/ga";
import "./styles.scss";

export interface IModalTermsConditionsProps {
  termsConditions: TermsConditions;
  onAccepted: () => void;
}

export const ModalTermsConditions: React.FunctionComponent<
  IModalTermsConditionsProps
> = ({ termsConditions, onAccepted }) => {
  const { t } = useTranslation();
  const { data: me } = useMe();
  const [isAccepted, setIsAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Send GA event on open
  useEffect(() => {
    modalViewGAEvent("terms-conditions-modal");
  }, []);

  const handleAccept = async () => {
    if (!me || !isAccepted) return;

    setIsSubmitting(true);
    try {
      await DataSvc.updateTermsConditionsSignature(
        Number(me.id).toString(),
        Number(termsConditions.id).toString(),
        { signed: true }
      );

      toast.success(t("termsConditions.acceptedSuccessfully"));
      onAccepted();
    } catch (error) {
      console.error("Failed to accept terms and conditions:", error);
      toast.error(t("termsConditions.acceptedFailed"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-terms-conditions">
      <div className="modal-overlay" />
      <div className="modal-content">
        <div className="modal-header">
          <h2>{t("termsConditions.title")}</h2>
        </div>

        <div className="modal-body">
          <div className="terms-content">
            <div
              className="terms-text"
              dangerouslySetInnerHTML={{ __html: termsConditions.content }}
            />
          </div>

          <div className="acceptance-section">
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={isAccepted}
                onChange={(e) => setIsAccepted(e.target.checked)}
                disabled={isSubmitting}
              />
              <span className="checkmark"></span>
              <span className="checkbox-text">
                {t("termsConditions.agreeToTerms")}
              </span>
            </label>
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-blue terms-conditions-accept-button"
            onClick={handleAccept}
            disabled={!isAccepted || isSubmitting}
          >
            {isSubmitting
              ? t("termsConditions.accepting")
              : t("termsConditions.acceptAndContinue")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalTermsConditions;
